export default {
  data: () => ({
        
    canvasForm: null,
    rawData:    null,

    table:      null,
    columns:    null,
    punch:      {},


  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {

      
    },

  }
}